import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TooltipComponent = ({ id, title, icon }) => {
  if (!id || !title) {
    return null;
  }

  const tooltip = (
    <Tooltip id={id} placement="top">
      {title}
    </Tooltip>
  );
  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <i>
        <FontAwesomeIcon icon={icon} id={id} />
      </i>
    </OverlayTrigger>
  );
}

TooltipComponent.defaultProps = {
  icon: ['far', 'circle-question'],
};

export default TooltipComponent;
